<footer>
  <ul>
    <li><i class="fas fa-cogs fa-lg"></i></li>
  </ul>
</footer>
